var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon.defined)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"mr-1",attrs:{"size":_vm.icon.size,"color":_vm.statusColor.icon}},'v-icon',attrs,false),on),[_vm._v(" "+_vm._s(_vm.icon.symbol)+" ")])]}}],null,false,2487349846)},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }